module.exports = __webpack_public_path__ + "static/media/ham-icon.d5b06683.png";